import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

// Connects to data-controller="choice"
export default class extends Controller {
  static targets = ["element"];

  connect() {
    this.choices = new Choices(this.elementTarget, {
      classNames: {
        choices__inner: ["form-input", "!p-0", "!text-sm"],
      },
    });

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          if (mutation.target.tagName === "SELECT") {
            this.refresh();
          }
        }
      }
    });

    observer.observe(this.elementTarget, {
      childList: true,
      subtree: true,
    });
  }

  refresh() {
    if (this.choices) {
      this.choices.destroy();
    }

    // Reinitialize with new options
    this.choices = new Choices(this.elementTarget, {
      classNames: {
        choices__inner: ["form-input", "!p-0", "!text-sm"],
      },
    });
  }
}
